import { Controller } from "@hotwired/stimulus"

// Controls a two-state (or multi-state) pill/radio toggle.
// Adds/removes an --active modifier class and updates aria-pressed.
export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    if (!this.buttonTargets.some((el) => el.classList.contains("fw-radio-button__button--active"))) {
      const first = this.buttonTargets[0]
      if (first) this.setActive(first)
    }
  }

  select(event) {
    event.preventDefault()
    this.setActive(event.currentTarget);
    this.inputTarget.value = event.currentTarget.dataset.value;
  }

  setActive(element) {
    this.buttonTargets.forEach((btn) => {
      btn.classList.remove("fw-radio-button__button--active")
      btn.setAttribute("aria-pressed", "false")
    })

    element.classList.add("fw-radio-button__button--active")
    element.setAttribute("aria-pressed", "true")
  }
}
